import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { Outlet } from 'react-router-dom';
import NavBar from './NavBar';

SimpleLayout.propTypes = { sidePadding: PropTypes.bool }

export default function SimpleLayout({ sidePadding = true })
{
  return <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }} >
    <NavBar />
    {sidePadding ? <Box sx={{ marginLeft: `max(3vw, 15px)`, marginRight: `max(3vw, 15px)`, height: "calc(100% - 150px)" }}>
      <Outlet />
    </Box> : <Outlet />}
  </Box>;
}
